import { useMemo } from "react";
import { useAtomValue } from "jotai";

import { ConversationPhase } from "shared/types";
import { noticeboardDataVar } from "@/variables/globalVar";

import { useExpertMapConfig } from "shared/hooks";
import { useAccount } from "@/hooks";

export function useIsReportReady() {
  const noticeboardData = useAtomValue(noticeboardDataVar);

  const { conversation } = useAccount();
  const expertMapConfig = useExpertMapConfig(conversation);
  const expertMap = expertMapConfig?.enquiry;

  return useMemo(() => {
    const reportReadyExperts = expertMap?.report_ready || [];

    return (
      [
        ConversationPhase.report_ready,
        ConversationPhase.amendment,
        ConversationPhase.saved_report,
        ConversationPhase.sent_to_council,
      ].includes(conversation?.phase as any) ||
      (conversation?.phase === ConversationPhase.ready_for_assessment &&
        reportReadyExperts.every((expertName) => expertName in noticeboardData))
    );
  }, [conversation?.phase, expertMap, noticeboardData]);
}
